import { useCurrentForm } from "@/components/Form"

export function useKeepMounted() {
  const { isSubmitted } = useCurrentForm()
  return isSubmitted
}
